import { getBuiltInWidgetConfigByWidget } from "components/dashboard/grid/helpers"
import { DEFAULT_COLOR } from "components/dashboard/widgets/colorConverter/utils"
import { HomePage } from "components/homepage"
import { Widget } from "domainModels/widget"
import { useRouter } from "next/router"
import React, { FC } from "react"
import { getModalMaxWidth, Modal } from "./modal"

interface Props {
  widget: Widget
}

export const PageModal: FC<Props> = ({ widget }) => {
  const { push } = useRouter()
  const builtInWidget = getBuiltInWidgetConfigByWidget(widget)

  let input

  if (widget.information.slug === "color-converter") {
    input = DEFAULT_COLOR
  } else if (widget.information.slug === "svg-converter") {
    input = `<svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="240" height="240" fill="#3730A3"/>
  <rect x="128" y="68" width="43" height="19" fill="#818CF8"/>
  <rect x="141" y="110" width="30" height="19" fill="#818CF8"/>
  <rect x="102" y="152" width="69" height="19" fill="#818CF8"/>
  <path d="M131 129H91.9973V171H68V68H118V86.9849H92V110H98.5H131V129Z" fill="white"/>
</svg>`
  } else if (widget.information.slug === "package-size") {
    input = "react"
  } else if (widget.information.slug === "json-converter") {
    input = `{"some":{"data":{"structure":1}}}`
  } else if (widget.information.slug === "css-converter") {
    input = `body{font-size:16px;}.someClass{color:red;}`
  } else if (widget.information.slug === "base64-converter") {
    input = "FEToolkit"
  } else if (widget.information.slug === "url-converter") {
    input = "https://www.fetoolkit.io/widget/url-converter"
  } else if (widget.information.slug === "js-converter") {
    input = `const a=5;
const b=3;
function sum(x,y) {return x + y;}
sum(a,b);`
  }

  return (
    <>
      <Modal
        show
        className={getModalMaxWidth(widget)}
        onClose={() => {
          push("/", "/", {
            scroll: false,
          })
        }}
      >
        {builtInWidget?.renderModal?.({ input, widget })}
      </Modal>
      <HomePage />
    </>
  )
}
